__turbopack_context__.v({
  "content": "NotFound-module-scss-module__WCBr8q__content",
  "link": "NotFound-module-scss-module__WCBr8q__link",
  "list": "NotFound-module-scss-module__WCBr8q__list",
  "listItem": "NotFound-module-scss-module__WCBr8q__listItem",
  "page404": "NotFound-module-scss-module__WCBr8q__page404",
  "subtitle": "NotFound-module-scss-module__WCBr8q__subtitle",
  "title": "NotFound-module-scss-module__WCBr8q__title",
});
